import { render } from "./GrupoEdit.vue?vue&type=template&id=9db08924"
import script from "./GrupoEdit.vue?vue&type=script&lang=js"
export * from "./GrupoEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__